var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"print"},[_c('schedule',{attrs:{"show-style":_vm.showStyle,"print":"","id":"schedule-print"},on:{"inited":_vm.handleExport}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }